import type { TCustomerData } from 'shared/types/TCustomerService';

/**
 * Маппер для передачи в creditFormSlice.customerData полей из белого списка,
 * чтобы не передавать все поля customerData, так как они есть в creditFormSlice.creditForm
 *
 * @param data - Partial<TCustomerData>
 * @returns Partial<TCustomerData>
 */

export const mapCustomerData = (data: Partial<TCustomerData>): Partial<TCustomerData> => {
  return {
    lastQuestionnaireUpdatedAt: data?.lastQuestionnaireUpdatedAt,
    workOrganizationName: data?.workOrganizationName,
    fullName: data?.fullName,
    passportNumber: data?.passportNumber,
    monthlySalary: data?.monthlySalary,
    loanPayments: data?.loanPayments,
    amount: data?.amount,
  };
};
